import { useState } from 'react';
import styled from 'styled-components';

import { utilService } from '../../../services/util-service';

interface ListItemProps {
  isConnect?: boolean;
  name?: string;
  phone?: string;
  time?: string;
  isLocation?: boolean;
  isMuted?: boolean;
  useCamera?: boolean;
  onClick?: (type: string) => void;
}

const UserItem = ({ isConnect, name, phone, time, isLocation, isMuted, useCamera, onClick }: ListItemProps) => {
  const [isSelected, setIsSelected] = useState(false);

  const onCall = () => {
    //
  };

  const setLocation = () => {
    //
  };

  return (
    <UserItemTemplate>
      <HorizontalWrap>
        <RotationWrap>
          <VerticalWrap onClick={onCall}>
            <PhoneText>
              {name !== null ? name + ' ' + utilService.isMobileFormat(phone) : utilService.isMobileFormat(phone)}
            </PhoneText>
            <PhoneText>{time}</PhoneText>
          </VerticalWrap>
        </RotationWrap>
        {isConnect ? (
          <img src={process.env.PUBLIC_URL + '/images/icon_send.svg'} alt="Send" />
        ) : (
          <img src={process.env.PUBLIC_URL + '/images/icon_connect.svg'} alt="Connect" />
        )}
      </HorizontalWrap>
      <Border />
    </UserItemTemplate>
  );
};

const UserItemTemplate = styled.div`
  width: 100%;
  height: 100%;
`;
const HorizontalWrap = styled.div`
  display: flex;
  position: relative;
  padding: 10px 16px;
`;
const VerticalWrap = styled.div`
  width: 100%;
  height: 100%;
`;
const Border = styled.div`
  width: 100%;
  height: 0px;
  border: 1px solid #000000;
`;
const PhoneText = styled.h1`
  margin 5px 0 10px 10px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
`;
const RotationWrap = styled.div`
  margin: auto;
  display: block;
  @media only screen and (min-width: 1920px) {
    display: flex;
  }
`;

export default UserItem;
